import { useState, useEffect } from 'react';

import getMatchedMedia from './getMatchedMedia';
import { BREAKPOINTS } from './breakpoints';
import addMediaListener from './addMediaListener';

export const useMediaListener = () => {
  const [matchedMedia, setMatchedMedia] = useState(BREAKPOINTS.handheld);
  useEffect(() => {
    const removeListener = addMediaListener(
      () => setMatchedMedia(getMatchedMedia()),
      true
    );
    return removeListener;
  }, [setMatchedMedia]);

  return matchedMedia;
};
